module.exports = __webpack_public_path__ + "static/media/hurman.2ba90336.webp";